import React, {Fragment} from "react";
import {DraaiType} from "../../../Model";
import ImageRadioPicker from "../../../components/ImageRadioPicker";
import PropTypes from "prop-types";
import imageAL from '../../../images/situation/draaitype/AL luik linksdraaiend.jpg';
import imageAR from '../../../images/situation/draaitype/AR luik rechtsdraaiend.jpg';
import imageB from '../../../images/situation/draaitype/B luik dubbel luik.jpg';
import imageCL from '../../../images/situation/draaitype/CL vouwluik linksdraaiend draaipunt binnen.jpg';
import imageCR from '../../../images/situation/draaitype/CR vouwluik rechtsdraaiend draaipunt binnen.jpg';
import imageDL from '../../../images/situation/draaitype/DL vouwluik linksdraaiend draaipunt buiten.jpg';
import imageDR from '../../../images/situation/draaitype/DR vouwluik rechtsdraaiend draaipunt buiten.jpg';
import imageE from '../../../images/situation/draaitype/E vouwluik links en vouwluik rechts draaipunt binnen.jpg';
import imageEL from '../../../images/situation/draaitype/EL vouwluik links draaipunt binnen en enkel luik rechts.jpg';
import imageER from '../../../images/situation/draaitype/ER enkel luik links en vouwluik rechts draaipunt binnen.jpg';
import imageF from '../../../images/situation/draaitype/F vouwluik links en vouwluik rechts draaipunt buiten.jpg';
import imageFL from '../../../images/situation/draaitype/FL vouwluik links draaipunt buiten en enkel luik rechts.jpg';
import imageFR from '../../../images/situation/draaitype/FR enkel luik links en vouwluik rechts draaipunt buiten.jpg';
import imageALO from '../../../images/situation/draaitype/ALO luik linksdraaiend overlappend.jpg';
import imageARO from '../../../images/situation/draaitype/ARO luik rechtsdraaiend overlappend.jpg';
import imageBLO from '../../../images/situation/draaitype/BLO dubbel luik- linkerluikoverlappend.jpg';
import imageBRO from '../../../images/situation/draaitype/BRO dubbel luik- rechterluikoverlappend.jpg';
import PickerInfoBox from "../../../components/PickerInfoBox";
import {validateAmountWithRotationType} from "../../../util/Validator";

DraaitypeWindow.propTypes = {
    currentValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    kozijnValue: PropTypes.string.isRequired,
    luikenValue: PropTypes.string.isRequired,
}

export default function DraaitypeWindow(props) {
    return <Fragment>
        <div className="phone-page-middle">
            <div className="phone-situation-title">
                Hier kunt u aangeven welk draaitype uw situatie heeft.<br/>
            </div>
            <div className="phone-pick-body">
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.AL}
                                  image={imageAL}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.AR}
                                  image={imageAR}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.B}
                                  image={imageB}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.CL}
                                  image={imageCL}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.CR}
                                  image={imageCR}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.DL}
                                  image={imageDL}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.DR}
                                  image={imageDR}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.E}
                                  image={imageE}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.EL}
                                  image={imageEL}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.ER}
                                  image={imageER}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.F}
                                  image={imageF}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.FL}
                                  image={imageFL}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.FR}
                                  image={imageFR}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.ALO}
                                  image={imageALO}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.ARO}
                                  image={imageARO}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.BLO}
                                  image={imageBLO}
                                  medium/>
                <ImageRadioPicker onSelect={props.onChange}
                                  current={props.currentValue}
                                  value={DraaiType.BRO}
                                  image={imageBRO}
                                  medium/>
            </div>
        </div>
        <PickerInfoBox
            options={[
                {value: DraaiType.AL, text: "Standaard linksdraaiend enkel luik"},
                {value: DraaiType.AR, text: "Standaard rechtsdraaiend enkel luik"},
                {value: DraaiType.B, text: "Standaard dubbelluik"},
                {value: DraaiType.CL, text: "Een linksdraaiend vouwluik met het draaipunt naar binnen"},
                {value: DraaiType.CR, text: "Een rechtsdraaiend vouwluik met het draaipunt naar binnen"},
                {value: DraaiType.DL, text: "Een linksdraaiend vouwluik met het draaipunt naar buiten"},
                {value: DraaiType.DR, text: "Een rechtsdraaiend vouwluik met het draaipunt naar buiten"},
                {value: DraaiType.E, text: "Dubbel vouwluik (rechts en links) met het draaipunt naar binnen"},
                {value: DraaiType.EL, text: "Vouwluik, met draaipunt naar binnen, links met enkel luik rechts"},
                {value: DraaiType.ER, text: "Vouwluik, met draaipunt naar binnen, rechts met enkel luik links"},
                {value: DraaiType.F, text: "Dubbel vouwluik (rechts en links) met het draaipunt naar buiten"},
                {value: DraaiType.FL, text: "Vouwluik met draaipunt naar buiten links met enkel luik rechts"},
                {value: DraaiType.FR, text: "Vouwluik met draaipunt naar buiten rechts met enkel luik links"},
                {value: DraaiType.ALO, text: "Linksdraaiend luik dat overlapt met een luik van een ander kozijn"},
                {value: DraaiType.ARO, text: "Rechtsdraaiend luik dat overlapt met een luik van een ander kozijn"},
                {value: DraaiType.BLO, text: "Dubbelluik dat overlapt met een ander luik aan de linkerkant"},
                {value: DraaiType.BRO, text: "Dubbelluik dat overlapt met een ander luik aan de rechterkant"},
            ]}
            current={props.currentValue}
            warnings={[
                ...validateAmountWithRotationType(-1, props.currentValue, props.kozijnValue, props.luikenValue, true)
            ]}
            sticky
        />
    </Fragment>
}